import React, { useState } from 'react'
import './App.css'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { RxHamburgerMenu } from "react-icons/rx"
import Login from './pages/Login'
import ForgotPassword from './pages/ForgotPassword'
import VerifyResetCode from './pages/VerifyResetCode'
import ResetPassword from './pages/ResetPassword'
import ChangePassword from './pages/ChangePassword'
import Home from './pages/Home'
import AdminLegacyCredits from './pages/adminPages/AdminLegacyCredits'
import Navbar from './components/Navbar'
import ProtectedRoute from './components/ProtectedRoute'
import AdminRoute from './components/AdminRoute'
import AdminLoans from './pages/adminPages/AdminLoans'
import Notices from './pages/Notices'
import Departments from './pages/Departments'
import DepartmentDetails from './pages/DepartmentDetails'
import EditDepartment from './pages/adminPages/EditDepartment'
import LoanDetails from './pages/LoanDetails'
import AdminLegacy from './pages/adminPages/AdminLegacyCredits'
import Investments from './pages/Investments'
import InvestmentDetails from './pages/InvestmentDetails'
import Users from './pages/Users'
import UserLegacyCredits from './pages/UserLegacyCredits'
import Profile from './pages/Profile'
import CreateUser from './pages/adminPages/CreateUser'
import CreateNotice from './pages/adminPages/CreateNotice'
import CreateDepartment from './pages/adminPages/CreateDepartment'
import CreateInvestment from './pages/adminPages/CreateInvestment'
import CreateLoan from './pages/adminPages/CreateLoan'
import EditUser from './pages/adminPages/EditUser'
import EditNotice from './pages/adminPages/EditNotice'
import EditInvestment from './pages/adminPages/EditInvestment'
import UserLoans from './pages/UserLoans'
import AddLegacyCredits from './pages/adminPages/AddLegacyCredits'
import EditLoan from './pages/adminPages/EditLoan'

const AppContent = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };
  
  return (
    <div className='App'>
      {location.pathname !== '/' && location.pathname !== '/login' && location.pathname !== '/forgot-password' && location.pathname !== '/verify-reset-code' && location.pathname !== '/reset-password' && (
        <>
          <button className={`hamburger-menu ${isMobileMenuOpen ? 'menu-open' : ''}`} onClick={toggleMobileMenu}>
            <RxHamburgerMenu size={24} />
          </button>
          <Navbar 
            className='navbar' 
            isMobileMenuOpen={isMobileMenuOpen} 
            onClose={closeMobileMenu} 
          />
        </>
      )}
      <div className={`routes ${(location.pathname === '/' || location.pathname === '/login' || location.pathname === '/forgot-password' || location.pathname === '/verify-reset-code' || location.pathname === '/reset-password') ? 'full-width' : ''}`}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify-reset-code" element={<VerifyResetCode />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
          <Route path='/home' element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path='/admin-legacy-credits' element={<ProtectedRoute><AdminLegacyCredits /></ProtectedRoute>} />
          <Route path='/user-legacy-credits' element={<ProtectedRoute><UserLegacyCredits /></ProtectedRoute>} />
          <Route path='/add-legacy-credits' element={<ProtectedRoute><AddLegacyCredits /></ProtectedRoute>} />
          <Route path='/notices' element={<ProtectedRoute><Notices /></ProtectedRoute>} />
          <Route path='/departments' element={<ProtectedRoute><Departments /></ProtectedRoute>} />
          <Route path='/department-details' element={<ProtectedRoute><DepartmentDetails /></ProtectedRoute>} />
          <Route path='/loan-details' element={<ProtectedRoute><LoanDetails /></ProtectedRoute>} />
          <Route path='/user-loans' element={<ProtectedRoute><UserLoans /></ProtectedRoute>} />
          <Route path='/admin-loans' element={<ProtectedRoute><AdminLoans /></ProtectedRoute>} />
          <Route path='/create-loan' element={<AdminRoute><CreateLoan /></AdminRoute>} />
          <Route path='/admin/edit-loan/:id' element={<AdminRoute><EditLoan /></AdminRoute>} />
          <Route path='/investments' element={<ProtectedRoute><Investments /></ProtectedRoute>} />
          <Route path='/investment-details' element={<ProtectedRoute><InvestmentDetails /></ProtectedRoute>} />
          <Route path='/profile' element={<ProtectedRoute><Profile /></ProtectedRoute>} />

          {/* Admin Routes */}
          <Route path='/admin-loans' element={<AdminRoute><AdminLoans /></AdminRoute>} />
          <Route path='/create-notice' element={<AdminRoute><CreateNotice /></AdminRoute>} />
          <Route path='/edit-notice' element={<AdminRoute><EditNotice /></AdminRoute>} />
          <Route path='/create-department' element={<AdminRoute><CreateDepartment /></AdminRoute>} />
          <Route path='/edit-department' element={<AdminRoute><EditDepartment /></AdminRoute>} />
          <Route path='/admin-legacy-credits' element={<AdminRoute><AdminLegacy /></AdminRoute>} />
          <Route path='/create-investment' element={<AdminRoute><CreateInvestment /></AdminRoute>} />
          <Route path='/edit-investment' element={<AdminRoute><EditInvestment /></AdminRoute>} />
          <Route path='/users' element={<AdminRoute><Users /></AdminRoute>} />
          <Route path='create-user' element={<AdminRoute><CreateUser /></AdminRoute>} />
          <Route path='edit-user' element={<AdminRoute><EditUser /></AdminRoute>} />
        </Routes>
      </div>
    </div>
  )
}

const App = () => {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  )
}

export default App